import createAsyncReducer from '../../core/helpers/createAsyncReducer';
import { INFO_TYPES} from '../../core/constants/actionTypes';


export const infoReducer = createAsyncReducer(INFO_TYPES.GET_INFO.PREFIX, {count: 0, informations: []});


